import clamp from "lodash/clamp";

export const clampValue = (
  value: string,
  constraints: { min?: string; max?: string },
): string => {
  const numeric = parseFloat(value);
  if (isNaN(numeric)) return value;

  const min = constraints.min ? parseFloat(constraints.min) : -Infinity;
  const max = constraints.max ? parseFloat(constraints.max) : Infinity;

  return clamp(numeric, min, max).toString();
};
